
import * as types from './actionTypes';

export const getMessageLog = (params) => ({type: types.MESSAGE_LOG_GET, params });

export const messageLogSuccess = (payload) => ({type: types.MESSAGE_LOG_SUCCESS, payload})

export const messageLogFail = (error) => ({ type: types.MESSAGE_LOG_FAIL, error });
